<template>
  <w-modal
    :showHeaderClose="false"
    :value="value"
    :width="448"
    @close="closeModal">
    <h1 slot="header">{{ title }}</h1>
    <div slot="content" class="modal-content">
      <p class="modal-content__description text-gray-500">通知訂購人員本次團購已開放領取。</p>
      <ul>
        <li
          v-for="item in notifyList"
          :key="`notify_${item.key}`"
          @click="item.enabled = !item.enabled"
          class="notify-item">
          <div>
            <p><span :class="['notify-icon', item.icon]" />{{ item.text }}</p>
            <span v-if="item.note" class="notify-note text-gray-500">{{ item.note }}</span>
          </div>
          <b-switch :value="item.enabled" @click.stop />
        </li>
      </ul>
    </div>
    <div slot="footer">
      <b-button
        @click="closeModal"
        class="is-cancel text-blue-500">
        取消
      </b-button>
      <b-button
        @click="sendNotifyImmediately"
        :disabled="isNotSend"
        type="is-primary">
        發送通知
      </b-button>
    </div>
  </w-modal>
</template>

<script>
import ReceiveNotificationModal from './ReceiveNotificationModal';

export default ReceiveNotificationModal;
</script>

<style lang="scss" scoped>
@import 'ReceiveNotificationModal';
</style>
